import { Component } from '@angular/core';
import { NgStyle } from '@angular/common';
import { RouterOutlet, RouterLink } from '@angular/router';

@Component({
   // eslint-disable-next-line @angular-eslint/component-selector
   selector: '<body[root]>',
   templateUrl: './auth-layout.component.html',
   styleUrl: './auth-layout.component.scss',
   standalone: true,
   imports: [
      RouterOutlet,
      NgStyle,
      RouterLink,
   ],
})
export class AuthLayoutComponent {
   today: Date = new Date();
}
